export default __webpack_public_path__ + "static/media/Planhyvlat 21.cc20ae46.jpg";